<template>
    <DCard
        :padding="padding"
        :title="title"
        :title-right="titleRight"
    >
        <template
            v-if="$slots['title-right']"
            #title-right
        >
            <slot name="title-right" />
        </template>
        <slot />
        <template
            v-if="$slots.footer"
            #footer
        >
            <slot name="footer" />
        </template>
    </DCard>
</template>

<script>
/**
 * Thin wrapper around `DCard` for sections on the certificate detail page:
 * applies the project's bold-title styling and defaults padding to true so
 * every card on the page renders with consistent spacing.
 */
export default {
    name: 'DetailsCard',
    props: {
        title: {
            type: String,
            default: ''
        },
        titleRight: {
            type: String,
            default: ''
        },
        padding: {
            type: Boolean,
            default: true
        }
    }
}
</script>
